import { useEffect, useState } from 'react';

/** Refresh time-based labels without refetching session data. */
export function useSessionClock(enabled = true): void {
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!enabled) return;
    const id = window.setInterval(() => setTick((n) => n + 1), 30_000);
    return () => window.clearInterval(id);
  }, [enabled]);
}
